import React, { useEffect, useRef, useState } from 'react';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { getPreCustomerByMsisdn } from '../redux/features/oxygen/oxygenRetailSlice';

const QoreIdLivenessCheck = () => {
  const dispatch = useDispatch();
  const { precustomerId, msisdn } = useSelector((state) => state?.precustomer?.precustomerData?.precustomer) || {};
  const customerData = useSelector((state) => state.oxygenRetail?.preCustomerDetailsByMsisdn?.data);
  console.log('customerData', customerData);
  const [sdkReady, setSdkReady] = useState(false);
  const qoreButtonRef = useRef(null);
  const email = customerData?.kyc_infos?.find((info) => info?.inputName === 'Email')?.inputValue;
  const phoneNo = customerData?.kyc_infos?.find((info) => info?.inputName === 'Msisdn')?.inputValue;

  const formatPhoneNumber = (rawPhone) => {
    if (!rawPhone) return '';
    return rawPhone.startsWith('0') ? `+234${rawPhone.slice(1)}` : rawPhone;
  };

  const phone = formatPhoneNumber(phoneNo);
  const data = { firstname:customerData?.fname, lastname: customerData?.lname, phone, email, };
  useEffect(() => {
    if (msisdn) {
      dispatch(getPreCustomerByMsisdn(msisdn));
    }
  }, [dispatch, msisdn]);

  // Load QoreID SDK
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://dashboard.qoreid.com/qoreid-sdk/qoreid.js';
    script.async = true;
    script.onload = () => {
      console.log('QoreID SDK Loaded');
      setSdkReady(true);
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Inject the QoreID Button
  useEffect(() => {
    if ( sdkReady && customerData?.id && email && phone && qoreButtonRef.current && window?.QoreIdRegenerateSDK) {
      const btn = document.createElement('qoreid-button');
      btn.setAttribute('id', 'QoreIDButton');
      btn.setAttribute('clientId', 'Y8S2C83TR4WUU2ITJUYY');
      btn.setAttribute('productCode', 'liveness_nin');
      btn.setAttribute('customerReference', customerData.id);
      btn.setAttribute('applicantData', JSON.stringify(data));

      // Clear and insert
      qoreButtonRef.current.innerHTML = '';
      qoreButtonRef.current.appendChild(btn);

      // Trigger SDK to scan and attach handlers
      window.QoreIdRegenerateSDK();
    }
  }, [sdkReady, customerData, email, phone]);

  return (
    <PageWrapper>
      <PageTitle title="Liveness Check" />
      <div className="py-5">
        <h1 className="text-center font-weight-semibold">Click the button to start liveness check</h1>
        <p className="text-center mt-5 mb-9 font-semibold size-lg">
          Carefully follow the instructions
        </p>
        <div ref={qoreButtonRef}></div>
      </div>
    </PageWrapper>
  );
};

export default QoreIdLivenessCheck;
